



























import { Vue, Component } from 'vue-property-decorator';
import { List, Swipe, SwipeItem } from 'vant';
import NewsItem from '@/components/next/NewsItem.vue';
import { getNews, getGold } from '../api';
import Swiper from 'swiper';
// import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.min.css';
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(List);
@Component({
  components: {
    NewsItem,
  },
})
export default class News extends Vue {
  list: any[] = [];
  page = 1;
  loading = false;
  finished = false;
  loadingStatus = true;
  refreshing: boolean = false;
  imageList:any = {};
  newsList: any = [];
  swiperOption: any = {
    spaceBetween: 270,
    slidesPerView: 2, // 一屏显示的slide个数
    centeredSlides: true, // 居中的slide是否标记为active，默认是最左active,这样样式即可生效
    slideToClickedSlide: true, // 点击的slide会居中
    loop: true, // 循环播放, 可有无限滚动效果，初始加载即是滚动后的效果
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
  }

  goDetail(a: any) {
    const url = a.targetUrl;
    window.location.href = url;
  }

  async getGolds() {
    const ret:any = await getGold();
    console.log(ret);
    this.imageList = ret.data
  }

  async getNews(){
    const res = await getNews(this.page, '全部', '9803');//9657
    this.newsList = res.data.data[0].list.splice(0, 4);
  }

  async created () {
    this.getGolds();
    this.getNews();
  }

  // onLoad() {
  //   getNews(this.page, '全部', '1').then((res: any) => {
  //     this.endListData(res);
  //   });
  //   this.getGolds();
  // }
  // endListData(res: any) {
  //   this.page = this.page + 1;
  //   if (res.statusCode === 404) {
  //     this.finished = true;
  //   } else {
  //     if (!res.data.data || res.data.data.length === 0) {
  //       this.finished = true;
  //     } else {
  //       if (!res.data.data[0].list || res.data.data[0].list.length === 0) {
  //         this.finished = true;
  //       } else {
  //         this.list = [...this.list, ...res.data.data[0].list];
  //       }
  //     }
  //   }
  //   this.loading = false;
  // }
  test(e: any) {
    // 默认会$event对象
    console.log(11, e);
  }
}
